window.FormValidator = {

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  },

  isValidPhone(phone) {
    return /^[0-9]{10}$/.test(phone); // simple 10 digit validation
  },

  minLength(value, length) {
    return value && value.trim().length >= length;
  },

  isChecked(selector, form) {
    return form.querySelectorAll(selector + ":checked").length > 0;
  },

  getCheckedValue(selector, form) {
    const el = form.querySelector(selector + ":checked");
    return el ? el.value : null;
  }

};